import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { theme } from "../../theme";
import styled, { css } from 'styled-components';
import { getBorderColor } from "../../theme/color-tokens";
export var Separator = function Separator(_ref) {
  var _theme$spaces$height;

  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 0 : _ref$gap,
      height = _ref.height,
      _ref$vertical = _ref.vertical,
      vertical = _ref$vertical === void 0 ? false : _ref$vertical,
      stretch = _ref.stretch,
      other = _objectWithoutProperties(_ref, ["color", "gap", "height", "vertical", "stretch"]);

  return /*#__PURE__*/React.createElement(StyledSeparator, _extends({
    role: "separator",
    $color: color,
    $gap: theme.spaces[gap] // height rule is only applied to vertical separators
    ,
    $height: (_theme$spaces$height = theme.spaces[height]) !== null && _theme$spaces$height !== void 0 ? _theme$spaces$height : height,
    $vertical: vertical,
    $stretch: stretch
  }, other));
};
var verticalSeparatorRules = css(["border-left:", " solid ", ";height:", ";margin-left:", ";padding-left:", ";"], theme.spaces.px, function (p) {
  return getBorderColor(p.$color);
}, function (p) {
  return p.$height;
}, function (p) {
  return p.$gap;
}, function (p) {
  return p.$gap;
});
var horizontalSeparatorRules = css(["border-bottom:", " solid ", ";margin-bottom:", ";padding-bottom:", ";"], theme.spaces.px, function (p) {
  return getBorderColor(p.$color);
}, function (p) {
  return p.$gap;
}, function (p) {
  return p.$gap;
});
export var StyledSeparator = styled.div.withConfig({
  displayName: "Separator__StyledSeparator",
  componentId: "vapor__abe026-0"
})(["", " ", ""], function (p) {
  return p.$vertical ? verticalSeparatorRules : horizontalSeparatorRules;
}, function (p) {
  return p.$stretch && "align-self: stretch;";
});